// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import * as Sentry from '@sentry/nextjs';

interface ErrorWithMessage {
  message?: string;
  stack?: string;
}

const pdpUrls = [
  '/daily-synbiotic',
  '/energy-focus',
  '/daily-multivitamin',
  '/daily-essentials-duo',
  '/sleep-restore',
];

// NEXT_PUBLIC_SENTRY_DSN is required client-side: Turbopack only inlines
// NEXT_PUBLIC_* vars into the browser bundle. A bare SENTRY_DSN is undefined here.
// fallback DSN is for local dev and uses 'my-seed-live-dev' project
// https://seed-19.sentry.io/settings/projects/my-seed-live-dev/
const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://fa250f873c2343058828ba0408a3e625@o968081.ingest.us.sentry.io/4504292022681600';

Sentry.init({
  dsn: SENTRY_DSN,
  tracesSampleRate: 0.0,
  ignoreErrors: [/o\.getFlow/, /SavvyFlow/],
  beforeSend(event, hint) {
    // Drop benign AbortErrors: aborted fetches / media loads cancelled on
    // navigation or unmount. DOMException code 20 is ABORT_ERR; some libraries
    // throw AbortError as a plain Error with no code, so check the name too.
    const abortErr = hint?.originalException as
      | { name?: string; code?: number }
      | undefined;
    if (
      abortErr &&
      typeof abortErr === 'object' &&
      (abortErr.name === 'AbortError' || abortErr.code === 20)
    ) {
      return null;
    }

    // Drop benign NotAllowedErrors: WebKit refuses video autoplay (Low Power
    // Mode, auto-play disabled) and rejects the play() promise; playback is
    // unaffected. Its DOMException code is 0, so match on the name only.
    const notAllowedErr = hint?.originalException as
      | { name?: string }
      | undefined;
    if (
      notAllowedErr &&
      typeof notAllowedErr === 'object' &&
      notAllowedErr.name === 'NotAllowedError'
    ) {
      return null;
    }

    if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent.toLowerCase();
      const inAppBrowsers = [
        'instagram',
        'facebook',
        'snapchat',
        'twitter',
        'tiktok',
      ];
      if (inAppBrowsers.some((browser) => ua.includes(browser))) {
        // Drop 90% of in-app browser errors
        if (Math.random() < 0.9) {
          return null;
        }
      }
    }

    const originalException = hint.originalException as
      | ErrorWithMessage
      | undefined;

    if (
      (pdpUrls.includes(window.location.pathname) &&
        (originalException?.message?.includes(
          `Cannot read properties of null (reading 'key')`,
        ) ||
          originalException?.message?.includes('o.getFlow is not a function') ||
          originalException?.message?.includes('stopWatchingForEditing'))) ||
      originalException?.stack?.includes(`trysavvy`)
    ) {
      return null;
    }

    const message =
      event.message ||
      (event.exception &&
        event.exception.values &&
        event.exception.values[0].value);

    if (message) {
      // Drop useless errors coming from Embeddables
      const patterns = [/o\.getFlow/, /SavvyFlow/];

      for (const pattern of patterns) {
        if (pattern.test(message)) {
          return null; // Drop the event
        }
      }
    }

    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
